const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCoberturasActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.45,4.76,11.9,1.41a.93.93,0,0,0-.8,0L3.65,4.72a1.07,1.07,0,0,0-.65,1v5a11.49,11.49,0,0,0,8.22,11,1.06,1.06,0,0,0,.56,0,11.49,11.49,0,0,0,8.22-11v-5A.94.94,0,0,0,19.45,4.76ZM16.13,9.51l-5.67,5.67a1,1,0,0,1-1.41,0L6.88,13a.85.85,0,0,1,0-1.23.88.88,0,0,1,1.23,0l1.51,1.51a.2.2,0,0,0,.27,0l5-5a.88.88,0,0,1,1.24,0h0A.87.87,0,0,1,16.13,9.51Z",
    style: {
      fill: "#663ea8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoberturasActive);
export default __webpack_public_path__ + "static/media/ic-coberturas-active.1ca353035da6f1eeda18990416e3e9da.svg";
export { ForwardRef as ReactComponent };